<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    isGallery?: boolean
    isNext: boolean
  }>(),
  { isGallery: false }
)

const emits = defineEmits<{
  (e: 'onButtonClick'): void
}>()

const ariaLabel = computed(() => props.isNext ? 'Вперёд' : 'Назад')
const svgIconName = computed(() => props.isNext ? 'outlined/navigate-next' : 'outlined/navigate-before')
</script>

<template>
  <button
    :aria-label="ariaLabel"
    class="flex cursor-pointer items-center justify-center rounded-full"
    :class="{
      'absolute top-[calc(50%-20px)] z-[2] hidden size-10 border border-solid border-main-gray bg-white text-main-blue sm:block': isGallery,
      'size-11 bg-[#5b5b5b]/20': !isGallery,
      'right-[calc(16px-20px)] xl:right-[calc(40px-20px)]': isGallery && isNext,
      'left-[calc(16px-20px)] xl:left-[calc(40px-20px)]': isGallery && !isNext
    }"
    @click="emits('onButtonClick')"
  >
    <SvgIcon class="text-2xl" :name="svgIconName" />
  </button>
</template>
